// Beach Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const skiHillRoom: Room = {
  name: 'Ski Hill',
  background: '/media/club-penguin/ski hill.webp',
  spawn: { x: 341, y: 338 },

  colliders: [
    ...STANDARD_BOUNDARIES,
    { x: 24, y: 17, w: 587, h: 107 },
    { x: 29, y: 124, w: 94, h: 389 },
    { x: 128, y: 115, w: 133, h: 100 },
    { x: 129, y: 334, w: 154, h: 198 },
    { x: 290, y: 379, w: 648, h: 148 },
    { x: 734, y: 324, w: 205, h: 53 },
    { x: 616, y: 29, w: 321, h: 96 },
    { x: 757, y: 123, w: 187, h: 105 },
  ],

  hotspots: [
    {
      id: 'ski-hill-to-ski-village',
      action: 'goto',
      target: 'ski-village',
      spawn: { x: 335, y: 320 },
      x: 753,
      y: 229,
      w: 78,
      h: 85,
    },
  ],
};
